module.exports = __webpack_public_path__ + "static/media/foot.60d109c2.svg";